import { render, staticRenderFns } from "./HeaderMobileNew.vue?vue&type=template&id=20d1cb81&"
import script from "./HeaderMobileNew.vue?vue&type=script&lang=js&"
export * from "./HeaderMobileNew.vue?vue&type=script&lang=js&"
import style0 from "./HeaderMobileNew.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./HeaderMobileNew.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports